<template>
  <ul>
    <li v-for="(t, index) in data" :key="index"> 
      <slot>{{ t.label }}</slot>
      <i class="fas fa-chevron-right" v-if="index !== data.length - 1"></i>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    data: {
      required: true
    }
  }
}
</script>

<style scoped>
ul {
  list-style: none;
  display: inline-flex;
  gap: 4px;
}

li i {
  margin: 0 4px
}
</style>